import { createSelector } from 'reselect';

export const getAuthoritiesReducer = state => state.authorities;

export const selectCanManageNetwork = createSelector(
  [getAuthoritiesReducer],
  ({ roles }) => roles.canManageNetwork,
);
